"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SideMenuItem = _interopRequireDefault(require("./SideMenuItem"));

var _jquery = _interopRequireDefault(require("jquery"));

var _index = require("../../../index");

var _services = require("../../../logic/services");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var SideBar = /*#__PURE__*/function (_Component) {
  _inherits(SideBar, _Component);

  function SideBar(props) {
    var _this;

    _classCallCheck(this, SideBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideBar).call(this, props));
    _this.state = {
      navigation: _this.getNavigation()
    };
    return _this;
  }

  _createClass(SideBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _jquery["default"])(window).width() < 1440) {
        this.closeSideMenu();
        (0, _jquery["default"])('#collapse').css({
          display: 'block',
          'margin-top': '12px'
        });
        (0, _jquery["default"])('.arrow').hide();
      }

      if ((0, _jquery["default"])('.dashboard-side').hasClass('collapsed')) {
        (0, _jquery["default"])('.arrow').hide();
      } else {// $('.sideMenuList').find('.sub-nav').parent().find('a').append('<i class="fa fa-angle-left arrow" aria-hidden="true"></i>');
      }

      var toggleMenu = function toggleMenu() {
        var el = (0, _jquery["default"])('.sideMenuList').find('> li').find('> a');
        el.click(function () {
          var elm = (0, _jquery["default"])(this);
          var parentLi = elm.closest('li');
          parentLi.closest('ul').children().not(parentLi).each(function (index, li) {
            var $li = (0, _jquery["default"])(li);
            $li.find('.sub-nav').slideUp();
            $li.find('.arrow').removeClass('arrow-down');
          }); // console.error(parentLi);

          elm.parent().find('.sub-nav').slideToggle();
          elm.parent().find('.arrow').toggleClass('arrow-down');
        }); // $('.sideMenuList').find('.sub-nav').parent().find('a').append('<i class="fa fa-angle-left arrow" aria-hidden="true"></i>');
      };

      toggleMenu();
    }
  }, {
    key: "showSideMenu",
    value: function showSideMenu() {
      (0, _jquery["default"])('.dashboard-side').removeClass('collapsed');
      (0, _jquery["default"])('.dashboard-main').removeClass('full-width');
      (0, _jquery["default"])('.dashboard-menu-top').removeClass('fullsize');
      (0, _jquery["default"])('.breadcrumb').removeClass('small');
      (0, _jquery["default"])('.collapse-menu').show();
      (0, _jquery["default"])('#collapse').hide();
      (0, _jquery["default"])('.sub-nav').css({
        display: 'none'
      });
      (0, _jquery["default"])('.sub-nav').removeClass('toggled-menu');
      (0, _jquery["default"])('.sideMenuList li a span').css({
        display: 'inline-block'
      }); // $('.sideMenuList').find('.sub-nav').parent().find('a').append('<i class="fa fa-angle-left arrow" aria-hidden="true"></i>');
    }
  }, {
    key: "closeSideMenu",
    value: function closeSideMenu() {
      (0, _jquery["default"])('.dashboard-side').addClass('collapsed');
      (0, _jquery["default"])('.dashboard-main').addClass('full-width');
      (0, _jquery["default"])('.dashboard-menu-top').addClass('fullsize');
      (0, _jquery["default"])('.breadcrumb').addClass('small');
      (0, _jquery["default"])('.collapse-menu').hide();
      (0, _jquery["default"])('#collapse').show();
      (0, _jquery["default"])('.sub-nav').css({
        display: 'none'
      });
      (0, _jquery["default"])('.sideMenuList li a span').css({
        display: 'none'
      });
      (0, _jquery["default"])('#collapse').css({
        position: 'relative',
        height: '40px'
      });
      (0, _jquery["default"])('.sub-nav').addClass('toggled-menu');
      (0, _jquery["default"])('.arrow').hide();
      (0, _jquery["default"])('.dashboard-main ').click(function () {
        (0, _jquery["default"])('.toggled-menu').css({
          display: 'none'
        });
      });
      (0, _jquery["default"])('.toggled-menu li').click(function () {
        (0, _jquery["default"])('.toggled-menu').css({
          display: 'none'
        });
      }); // let sideMenu = function () {
      //   let el = $('.sideMenuList li');
      //   el.hover(function () {
      //     let elm = $(this);
      //     elm.find('.toggled-menu').addClass('visible');
      //   }, function () {
      //     let elm = $(this);
      //     elm.find('.toggled-menu').removeClass('visible');
      //   });
      // }
      // sideMenu();
    }
  }, {
    key: "getNavigation",
    value: function getNavigation() {
      return _services.OverrideService.getSideNavigation([{
        label: 'Dashboard',
        icon: 'tachometer',
        path: '/'
      }, {
        label: 'KYC',
        slug: 'kyc',
        icon: 'tachometer',
        path: null,
        children: [{
          label: 'Dashboard',
          icon: 'tachometer',
          path: '/kyc'
        }, {
          label: 'Requests',
          icon: 'list',
          path: '/kyc/requests'
        }]
      }, {
        label: 'Users',
        icon: 'users',
        path: null,
        children: [{
          label: 'All Users',
          path: '/users/all-users',
          icon: 'users'
        }, {
          label: ' User Devices',
          path: '/users/user-devices',
          icon: 'laptop'
        }]
      }, {
        label: 'Cards',
        icon: 'credit-card',
        path: '/cards'
      }, {
        label: 'Transactions',
        icon: 'exchange',
        path: '/transaction'
      }, // {
      //   label: 'Card Management',
      //   // icon: 'credit-card',
      //   icon: 'credit-card-alt',
      //   path: null,
      //   children: [
      //     {
      //       label: 'Card Types',
      //       path: '/card-management/card-types',
      //       icon: 'credit-card'
      //     }, {
      //       label: 'Card Categories',
      //       path: '/card-management/card-categories',
      //       icon: 'th'
      //     }, {
      //       label: 'Card Products',
      //       path: '/card-management/card-products',
      //       icon: 'product-hunt'
      //     },
      // {
      //   label: 'PAN Ranges',
      //   path: '/card-management/pan-ranges',
      //   icon: 'list'
      // }, {
      //   label: 'Serial No. Ranges',
      //   path: '/card-management/serial-ranges',
      //   icon: 'list'
      // }
      //   ]
      // },
      // {
      //   label: 'Analytics',
      //   icon: 'bar-chart',
      //   path: null,
      //   children: [
      //     {
      //       label: 'Schools',
      //       path: '/analytics/schools',
      //       icon: 'university'
      //     },
      //     {
      //       label: 'Projects',
      //       path: '/analytics/projects',
      //       icon: 'rocket'
      //     },
      //     {
      //       label: 'Donations',
      //       path: '/analytics/donations',
      //       icon: 'money'
      //     },
      //     {
      //       label: 'Cards',
      //       path: '/analytics/cards',
      //       icon: 'credit-card',
      //       children: [
      //         {
      //           label: 'Activated cards',
      //           path: '/analytics/cards/activated',
      //           icon: 'line-chart'
      //         },
      //         {
      //           label: 'Loaded cards',
      //           path: '/analytics/cards/loaded',
      //           icon: 'line-chart'
      //         },
      //         {
      //           label: 'Card Spending',
      //           path: '/analytics/cards/spending',
      //           icon: 'line-chart'
      //         },
      //         {
      //           label: 'Card Expiration',
      //           path: '/analytics/cards/expiration',
      //           icon: 'line-chart'
      //         },
      //         // {
      //         //   label: 'Uplift',
      //         //   path: '/analytics/uplift',
      //         //   icon: 'arrow-up'
      //         // },
      //       ]
      //     },
      //     // {
      //     //   label: 'Cards',
      //     //   path: '/card-management/activated',
      //     //   icon: 'list',
      //     //   children: [
      //     //     {
      //     //       label: 'Issued Cards',
      //     //       path: '/card-management/activated',
      //     //       icon: 'power-off'
      //     //     },
      //     //     //  {
      //     //     //   label: 'Redeemed Cards',
      //     //     //   path: '/card-management/redeemed',
      //     //     //   icon: 'money'
      //     //     // },
      //     //     //  {
      //     //     //   label: 'Reloaded Cards',
      //     //     //   path: '/card-management/reloaded',
      //     //     //   icon: 'refresh'
      //     //     // },
      //     //     {
      //     //       label: 'Card Stock',
      //     //       path: '/card-management/stock',
      //     //       icon: 'database'
      //     //     }
      //     //   ]
      //     // },
      //     // {
      //     //   label: 'Promotions',
      //     //   path: '/analytics/promotions',
      //     //   icon: 'gift'
      //     // },
      //     {
      //       label: 'Customers',
      //       path: '/analytics/customers',
      //       icon: 'user'
      //     },
      //   ]
      // },
      {
        label: 'Content Management',
        icon: 'cog',
        path: null,
        slug: 'content-management',
        children: [{
          label: 'Config',
          icon: 'cogs',
          path: '/config'
        }, {
          label: 'Faq',
          icon: 'question-circle',
          path: '/faq',
          slug: 'faq'
        }, {
          label: 'Countries',
          path: '/countries',
          icon: 'map'
        }, {
          label: 'Currencies',
          path: '/currencies',
          icon: 'money'
        }, {
          label: 'Transaction Categories',
          path: '/transaction-categories',
          icon: 'exchange'
        }, {
          label: 'Transaction Merchant',
          path: '/transaction-merchant',
          icon: 'exchange'
        }, {
          label: 'Merchant Category Code',
          path: '/merchant-category-code',
          icon: 'barcode'
        }]
      }, // {
      //   label: 'FundStar',
      //   icon: 'star',
      //   path: null,
      //   children: [
      //     {
      //       label: 'Schools',
      //       icon: 'university',
      //       path: '/schools'
      //     },
      //     {
      //       label: 'Projects',
      //       icon: 'rocket',
      //       path: '/projects'
      //     },
      //     {
      //       label: 'Donation Group',
      //       icon: 'handshake-o',
      //       path: '/donation-group'
      //     }
      //   ]
      // },
      {
        label: 'Reports',
        icon: 'file',
        path: null,
        children: [{
          label: 'Totals',
          path: '/reports/totals',
          icon: 'globe'
        }, // {
        //   label: 'Schools',
        //   path: '/reports/schools',
        //   icon: 'university'
        // },
        // {
        //   label: 'Projects',
        //   path: '/reports/projects',
        //   icon: 'rocket'
        // },
        {
          label: 'Cards',
          path: '/reports/cards',
          icon: 'credit-card'
        } // {
        //   label: 'Donations',
        //   path: '/reports/donations',
        //   icon: 'money'
        // },
        // {
        //   label: 'Donations',
        //   path: '/reports/distributed-donations',
        //   icon: 'money'
        // },
        // {
        //   label: 'Cardholders',
        //   path: '/reports/cardholders',
        //   icon: 'balance-scale'
        // },
        // {
        //   label: 'Fees',
        //   path: '/reports/fees',
        //   icon: 'balance-scale'
        // },
        // {
        //   label: 'Gift Aid',
        //   path: '/reports/giftaid',
        //   icon: 'balance-scale'
        // },
        ]
      }, {
        label: 'Legal',
        icon: 'balance-scale',
        path: null,
        children: [{
          label: 'Terms and Conditions',
          path: '/terms',
          icon: 'balance-scale'
        }, {
          label: 'Privacy Policy',
          path: '/privacy',
          icon: 'balance-scale'
        }]
      }, {
        label: 'Notifications',
        icon: 'bell',
        // path: '/push-notifications',
        children: [{
          label: 'Send new notification',
          path: '/push-notifications/add-new',
          icon: 'paper-plane'
        }, {
          label: 'Sent notifications',
          path: '/push-notifications',
          icon: 'bell'
        }, {
          label: 'User Groups',
          path: '/user-groups',
          icon: 'users'
        }]
      }, {
        label: 'Tools',
        icon: 'cog',
        path: null,
        children: [{
          label: 'Bulk Load',
          icon: 'plus',
          path: '/tools/bulk-load'
        }]
      }]);
    }
  }, {
    key: "render",
    value: function render() {
      var items = [];
      this.state.navigation.forEach(function (item, index) {
        var key = 'side-menu-item-' + index;
        items.push(_react["default"].createElement(_SideMenuItem["default"], _extends({}, item, {
          key: key
        })));
      });
      return _react["default"].createElement("div", {
        className: "dashboard-side"
      }, _react["default"].createElement(_index.LPOverridable, {
        name: 'sidemenu.logo'
      }, _react["default"].createElement("div", {
        className: "dash-logo"
      }, _react["default"].createElement("img", {
        src: require('../../../assets/Launchpad_logoWhite.png'),
        alt: ""
      }))), _react["default"].createElement("div", {
        className: "side-menu"
      }, _react["default"].createElement("i", {
        id: "collapse",
        onClick: this.showSideMenu,
        style: {
          color: '#fff'
        },
        className: "fa fa-bars",
        "aria-hidden": "true"
      }), _react["default"].createElement("p", {
        className: "collapse-menu",
        onClick: this.closeSideMenu
      }, _react["default"].createElement("i", {
        style: {
          color: '#fff'
        },
        className: "fa fa-angle-double-left",
        "aria-hidden": "true"
      }), "Collapse menu"), _react["default"].createElement("ul", {
        className: "sideMenuList"
      }, items)));
    }
  }]);

  return SideBar;
}(_react.Component);

exports["default"] = SideBar;